(function (root) {
  var DEFAULT_BASE = '/apps/ed-favorites';
  var EVENT_NAME = 'ed:company-favorites-updated';

  function numericId(value) {
    if (value == null || value === '') return '';
    var text = String(value);
    var gid = text.match(/(\d+)\s*$/);
    if (gid) return gid[1];
    return text.replace(/\D/g, '') || '';
  }

  function uniqueIds(ids) {
    var seen = {};
    var out = [];
    (ids || []).forEach(function (value) {
      var id = numericId(value);
      if (!id || seen[id]) return;
      seen[id] = true;
      out.push(id);
    });
    return out;
  }

  function toIdSet(ids) {
    var set = {};
    uniqueIds(ids).forEach(function (id) {
      set[id] = true;
    });
    return set;
  }

  function hasId(ids, productId) {
    var id = numericId(productId);
    if (!id) return false;
    var list = Array.isArray(ids) ? ids : [];
    for (var i = 0; i < list.length; i++) {
      if (numericId(list[i]) === id) return true;
    }
    return false;
  }

  function applyToggle(ids, productId, action) {
    var id = numericId(productId);
    var next = uniqueIds(ids);
    if (!id) return next;
    if (action === 'remove') {
      return next.filter(function (entry) {
        return entry !== id;
      });
    }
    if (!hasId(next, id)) next.push(id);
    return next;
  }

  function isRestrictedProduct(productId, restrictedIds, isShownId) {
    var id = numericId(productId);
    if (!id) return false;
    if (hasId(restrictedIds, id)) return true;
    if (typeof isShownId === 'function') return !!isShownId(id);
    return false;
  }

  function shouldKeepRow(productId, savedIds, restrictedIds, isShownId) {
    if (isRestrictedProduct(productId, restrictedIds, isShownId)) return true;
    return hasId(savedIds, productId);
  }

  function shouldKeepFavoritesRow(productId, savedIds, restrictedIds) {
    if (hasId(restrictedIds, productId)) return true;
    return hasId(savedIds, productId);
  }

  function applyFavoritesTable(opts) {
    opts = opts || {};
    var collection = opts.collectionItems;
    if (!collection || !collection.length) collection = opts.items || [];
    return mergeUsfItems(collection, {
      favoritesPage: true,
      savedProducts: opts.savedProducts || [],
      savedIds: opts.savedIds || [],
      restrictedIds: opts.restrictedIds || [],
      hiddenIds: opts.hiddenIds || [],
      isShownId: opts.isShownId,
    });
  }

  function isFailedToggleResult(result) {
    if (!result) return true;
    if (result.networkError) return true;
    if (!result.ok || result.status === 0) return true;
    if (result.status === 401 || result.status === 403) return true;
    var data = result.data;
    return !data || data.ok !== true || !Array.isArray(data.productIds);
  }

  function toggleFailureKind(result) {
    if (result && result.status === 401) return 'login';
    if (result && result.status === 403) return 'company';
    return 'error';
  }

  function itemId(item) {
    if (!item) return '';
    return numericId(item.id || item.productId || item.product_id || item.pid);
  }

  var USF_OPEN_QTY = -2147483648;

  function coerceUsfId(value) {
    if (value == null || value === '') return null;
    var asNum = Number(numericId(value));
    if (asNum && isFinite(asNum)) return asNum;
    return value;
  }

  function usfVariantAvailable(variant, productAvailable) {
    if (!variant) return productAvailable ? USF_OPEN_QTY : 0;
    var raw = variant.available;
    if (raw === USF_OPEN_QTY) return USF_OPEN_QTY;
    if (typeof raw === 'number' && isFinite(raw)) {
      if (raw > 0) return raw;
      if (raw === 0 && (variant.inventory_policy === 'continue' || (variant.flags & 1))) return USF_OPEN_QTY;
      return 0;
    }
    if (raw === true) return USF_OPEN_QTY;
    if (raw === false) return 0;
    var qty = Number(variant.inventory_quantity);
    if (qty > 0) return qty;
    if (productAvailable) return USF_OPEN_QTY;
    return 0;
  }

  function usfVariantFlags(variant) {
    if (variant && typeof variant.flags === 'number') return variant.flags;
    if (variant && variant.inventory_policy === 'continue') return 1;
    return 0;
  }

  function usfItemInStock(item) {
    if (!item) return false;
    var variants = item.variants || [];
    var selected = item.selectedVariantId;
    var variant = null;
    if (selected != null) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i] && variants[i].id === selected) {
          variant = variants[i];
          break;
        }
      }
    }
    if (!variant) variant = variants[0];
    if (!variant) return item.available !== false && item.available !== 0;
    var qty = variant.available;
    return !!(1 & (variant.flags || 0)) || qty > 0 || qty === USF_OPEN_QTY;
  }

  function cloneUsfProduct(item) {
    if (!item) return item;
    var next = {};
    Object.keys(item).forEach(function (key) {
      next[key] = item[key];
    });
    if (Array.isArray(item.variants)) {
      next.variants = item.variants.map(function (variant) {
        if (!variant) return variant;
        var copy = {};
        Object.keys(variant).forEach(function (key) {
          copy[key] = variant[key];
        });
        return copy;
      });
    }
    return next;
  }

  function normalizeUsfItem(item) {
    if (!item) return item;
    // USF builds row links from item.urlName (usf.platform.getProductUrl). Saved favourites that
    // are injected from /products/<handle>.js only carried `handle`, so their links pointed at
    // /collections/<page collection>/products/undefined and returned 404.
    if (!item.urlName) {
      var urlHandle = item.handle || '';
      if (!urlHandle && item.url) {
        var m = String(item.url).match(/\/products\/([^/?#]+)/);
        if (m) urlHandle = decodeURIComponent(m[1]);
      }
      if (urlHandle) item.urlName = urlHandle;
    }
    var productAvailable = item.available !== false && item.available !== 0;
    var variants = Array.isArray(item.variants) ? item.variants.slice() : [];
    if (!variants.length) {
      variants = [
        {
          id: coerceUsfId(item.selectedVariantId || item.variantId || item.variant_id),
          sku: item.sku || '',
          price: item.price,
          available: productAvailable ? USF_OPEN_QTY : 0,
          flags: 0,
        },
      ];
    }
    item.variants = variants.map(function (variant) {
      var next = {};
      if (variant) {
        Object.keys(variant).forEach(function (key) {
          next[key] = variant[key];
        });
      }
      next.id = coerceUsfId(next.id || item.selectedVariantId);
      next.available = usfVariantAvailable(next, productAvailable);
      next.flags = usfVariantFlags(next);
      if (next.price == null && item.price != null) next.price = item.price;
      return next;
    });
    var selected = coerceUsfId(item.selectedVariantId);
    var hasSelected = item.variants.some(function (variant) {
      return variant && variant.id === selected;
    });
    if (!hasSelected) selected = item.variants[0] && item.variants[0].id;
    item.selectedVariantId = selected;
    var coercedId = coerceUsfId(item.id);
    if (coercedId != null) item.id = coercedId;
    if (typeof item.available !== 'number') item.available = productAvailable ? USF_OPEN_QTY : 0;
    return item;
  }

  function mergeTableItems(opts) {
    opts = opts || {};
    var savedIds = toIdSet(opts.savedIds);
    var restrictedIds = toIdSet(opts.restrictedIds);
    var hiddenIds = toIdSet(opts.hiddenIds);
    var seen = {};
    var out = [];

    function allow(id) {
      if (!id || seen[id] || hiddenIds[id]) return false;
      if (restrictedIds[id]) return true;
      if (typeof opts.isShownId === 'function' && opts.isShownId(id)) return true;
      return !!savedIds[id];
    }

    function push(item) {
      var id = itemId(item);
      if (!allow(id)) return;
      seen[id] = true;
      out.push(normalizeUsfItem(cloneUsfProduct(item)));
    }

    (opts.collectionItems || []).forEach(push);
    (opts.savedProducts || []).forEach(push);
    return out;
  }

  function mergeUsfItems(items, opts) {
    opts = opts || {};
    if (!opts.favoritesPage) return items || [];
    return mergeTableItems({
      collectionItems: items || [],
      savedProducts: opts.savedProducts || [],
      savedIds: opts.savedIds || [],
      restrictedIds: opts.restrictedIds || [],
      hiddenIds: opts.hiddenIds || [],
      isShownId: opts.isShownId,
    });
  }

  function insertedFavoriteItems(merged, existingItems) {
    var before = {};
    (existingItems || []).forEach(function (item) {
      var id = itemId(item);
      if (id) before[id] = true;
    });
    return (merged || []).filter(function (item) {
      var id = itemId(item);
      return id && !before[id];
    });
  }

  function rewriteProductJsonUrl(url) {
    if (typeof url !== 'string') return url;
    return url.replace(/(\/products\/[^/?#]+)\.json(\?.*)?$/i, '$1.js$2');
  }

  function toastViewportPin(opts) {
    opts = opts || {};
    var viewH = Number(opts.viewHeight) || 0;
    var viewTop = Number(opts.viewTop) || 0;
    var toastH = Number(opts.toastHeight) || 0;
    var bannerTop = opts.bannerTop;
    var bannerHeight = Number(opts.bannerHeight) || 0;
    var bottomPad = 24;
    if (bannerTop != null && bannerHeight > 0 && bannerTop < viewH && bannerTop + bannerHeight > viewH - 240) {
      bottomPad = Math.max(bottomPad, Math.round(viewH - bannerTop + 12));
    }
    return {
      top: Math.max(0, Math.round(viewTop + viewH - bottomPad - toastH)),
      bottomPad: bottomPad,
    };
  }

  function isIgnorableFavoritesResult(result) {
    if (!result) return true;
    if (result.ok && result.data && result.data.ok === true && Array.isArray(result.data.productIds)) return false;
    return true;
  }

  function snapshotState(state) {
    return {
      productIds: uniqueIds(state.productIds),
      pendingAction: state.pendingAction || null,
    };
  }

  function applyOptimistic(state, productId, action) {
    var snap = snapshotState(state);
    state.productIds = applyToggle(state.productIds, productId, action);
    state.pendingAction = { productId: numericId(productId), action: action };
    return snap;
  }

  function rollbackOptimistic(state, snap) {
    if (!snap) return state;
    state.productIds = uniqueIds(snap.productIds);
    state.pendingAction = null;
    return state;
  }

  function applyServerList(state, productIds) {
    state.productIds = uniqueIds(productIds);
    state.pendingAction = null;
    return state.productIds;
  }

  function shopJsToUsfItem(data) {
    if (!data) return null;
    var variants = data.variants || [];
    var variant = variants[0] || {};
    var images = (data.images || []).map(function (img) {
      if (!img) return null;
      if (typeof img === 'string') return { url: img };
      return { url: img.url || img.src || '' };
    }).filter(function (img) {
      return img && img.url;
    });
    var featured = data.featured_image;
    if (typeof featured === 'object' && featured) featured = featured.src || featured.url || '';
    return normalizeUsfItem({
      id: data.id,
      title: data.title || '',
      handle: data.handle || '',
      url: data.url || (data.handle ? '/products/' + data.handle : ''),
      available: data.available !== false,
      price: data.price,
      priceMin: data.price_min != null ? data.price_min : data.price,
      productType: data.type || data.product_type || '',
      sku: variant.sku || data.sku || '',
      selectedVariantId: variant.id || data.selected_or_first_available_variant_id || null,
      images: images,
      featured_image: featured || (images[0] && images[0].url) || '',
      variants: variants,
      metafields: data.metafields || [],
    });
  }

  var logic = {
    DEFAULT_BASE: DEFAULT_BASE,
    numericId: numericId,
    uniqueIds: uniqueIds,
    hasId: hasId,
    applyToggle: applyToggle,
    isRestrictedProduct: isRestrictedProduct,
    shouldKeepRow: shouldKeepRow,
    shouldKeepFavoritesRow: shouldKeepFavoritesRow,
    applyFavoritesTable: applyFavoritesTable,
    isFailedToggleResult: isFailedToggleResult,
    toggleFailureKind: toggleFailureKind,
    mergeTableItems: mergeTableItems,
    mergeUsfItems: mergeUsfItems,
    insertedFavoriteItems: insertedFavoriteItems,
    rewriteProductJsonUrl: rewriteProductJsonUrl,
    toastViewportPin: toastViewportPin,
    isIgnorableFavoritesResult: isIgnorableFavoritesResult,
    applyOptimistic: applyOptimistic,
    rollbackOptimistic: rollbackOptimistic,
    applyServerList: applyServerList,
    shopJsToUsfItem: shopJsToUsfItem,
    normalizeUsfItem: normalizeUsfItem,
    usfItemInStock: usfItemInStock,
    snapshotState: snapshotState,
  };

  root.__edCompanyFavoritesLogic = logic;
  if (root.__edFavoritesLogicOnly) return;

  var cfg = root.__edCompanyFavorites || {};
  var state = {
    basePath: String(cfg.basePath || DEFAULT_BASE).replace(/\/+$/, '') || DEFAULT_BASE,
    loginUrl: cfg.loginUrl || '/account/login',
    loggedIn: !!cfg.loggedIn,
    hasCompany: !!cfg.hasCompany,
    productIds: uniqueIds(cfg.productIds || root.__edCompanyWishlistProductIds || []),
    products: Array.isArray(cfg.products) && cfg.products.length
      ? cfg.products.slice()
      : Array.isArray(root.__edCompanyWishlistProducts)
        ? root.__edCompanyWishlistProducts.slice()
        : [],
    restrictedIds: uniqueIds(
      cfg.restrictedIds && cfg.restrictedIds.length ? cfg.restrictedIds : root.__edRestrictedProductIds || []
    ),
    isFavoritesPage: !!(cfg.isFavoritesPage || root.__edFavoritesPage || root.__edSpecialProductsPage),
    i18n: cfg.i18n || {},
    pendingAction: null,
    inflight: {},
    collectionItems: [],
  };

  function publishConfig() {
    root.__edCompanyWishlistProductIds = state.productIds.slice();
    root.__edCompanyFavorites = {
      basePath: state.basePath,
      loginUrl: state.loginUrl,
      loggedIn: state.loggedIn,
      hasCompany: state.hasCompany,
      productIds: state.productIds.slice(),
      products: state.products,
      restrictedIds: state.restrictedIds.slice(),
      isFavoritesPage: state.isFavoritesPage,
      i18n: state.i18n,
      isSaved: isSaved,
      toggle: toggle,
      refreshHearts: syncHearts,
    };
    if (typeof root.dispatchEvent === 'function' && typeof root.CustomEvent === 'function') {
      root.dispatchEvent(new root.CustomEvent(EVENT_NAME, { detail: { productIds: state.productIds.slice() } }));
    }
    var doc = root.document;
    if (doc && typeof doc.dispatchEvent === 'function' && typeof root.CustomEvent === 'function') {
      doc.dispatchEvent(new root.CustomEvent(EVENT_NAME, { detail: { productIds: state.productIds.slice() } }));
    }
  }

  function isSaved(productId) {
    return hasId(state.productIds, productId);
  }

  function shownChecker() {
    var gate = root.__edDragonGateUsf;
    if (gate && typeof gate.isShownId === 'function') {
      return function (id) {
        return gate.isShownId(id);
      };
    }
    return null;
  }

  function hiddenCheckerId(id) {
    var gate = root.__edDragonGateUsf;
    if (gate && typeof gate.isHiddenId === 'function') return !!gate.isHiddenId(id);
    return false;
  }

  function loginRedirect() {
    var url = state.loginUrl || '/account/login';
    try {
      var next = root.location.pathname + (root.location.search || '');
      if (next && url.indexOf('return_url=') === -1) {
        url += (url.indexOf('?') === -1 ? '?' : '&') + 'return_url=' + encodeURIComponent(next);
      }
    } catch (e) {}
    root.location.href = url;
  }

  function cookieBannerBox(doc) {
    var nodes = doc.querySelectorAll(
      '#shopify-pc__banner, #shopify-pc-banner, [id*="shopify-pc"], [data-shopify-privacy], .shopify-privacy-banner'
    );
    var viewH = (root.visualViewport && root.visualViewport.height) || root.innerHeight || 0;
    var best = null;
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (!node || !node.getBoundingClientRect) continue;
      var rect = node.getBoundingClientRect();
      if (!rect || !rect.height) continue;
      if (rect.bottom > viewH - 240 && rect.top < viewH) {
        if (!best || rect.top < best.top) best = rect;
      }
    }
    return best;
  }

  function ancestorTransformed(el, doc) {
    var node = el && el.parentNode;
    while (node && node.nodeType === 1 && node !== doc.documentElement) {
      try {
        var cs = root.getComputedStyle ? root.getComputedStyle(node) : null;
        if (
          cs &&
          ((cs.transform && cs.transform !== 'none') ||
            (cs.filter && cs.filter !== 'none') ||
            (cs.perspective && cs.perspective !== 'none'))
        ) {
          return true;
        }
      } catch (e) {}
      node = node.parentNode;
    }
    return false;
  }

  function pinErrorHost(host, el) {
    var doc = root.document;
    if (!doc || !host) return;
    var body = doc.body;
    if (body && host.parentNode !== body) body.appendChild(host);
    var vv = root.visualViewport;
    var viewH = (vv && vv.height) || root.innerHeight || 0;
    var scrollY = root.pageYOffset || (doc.documentElement && doc.documentElement.scrollTop) || (body && body.scrollTop) || 0;
    var viewTop = scrollY + ((vv && vv.offsetTop) || 0);
    var banner = cookieBannerBox(doc);
    var pin = toastViewportPin({
      viewHeight: viewH,
      viewTop: viewTop,
      bannerTop: banner ? banner.top : null,
      bannerHeight: banner ? banner.height : 0,
      toastHeight: (el && el.offsetHeight) || 0,
    });
    host.style.left = '0';
    host.style.right = '0';
    host.style.width = '100%';
    host.style.zIndex = '2147483000';
    host.style.pointerEvents = 'none';
    host.style.display = 'flex';
    host.style.justifyContent = 'center';
    host.style.alignItems = 'flex-end';
    host.style.transform = 'none';
    host.style.filter = 'none';
    if (ancestorTransformed(host, doc)) {
      host.style.position = 'absolute';
      host.style.top = pin.top + 'px';
      host.style.bottom = 'auto';
      host.style.paddingBottom = '0';
    } else {
      host.style.position = 'fixed';
      host.style.top = 'auto';
      host.style.bottom = '0';
      host.style.paddingBottom = pin.bottomPad + 'px';
    }
  }

  function showError(message) {
    var text = message || state.i18n.error || 'Kunne ikke opdatere gemte produkter. Prøv igen.';
    var doc = root.document;
    if (!doc || !doc.createElement) {
      if (root.console && root.console.warn) root.console.warn(text);
      return;
    }
    var host;
    var el;
    try {
      host = doc.getElementById('ed-fav-error-host');
      if (!host) {
        host = doc.createElement('div');
        host.id = 'ed-fav-error-host';
        host.setAttribute('data-ed-fav-error-host', '');
      }
      var mount = doc.body || doc.documentElement;
      if (mount && host.parentNode !== mount) mount.appendChild(host);
      host.removeAttribute('hidden');
      host.setAttribute('data-ed-fav-error-text', text);
      host.style.display = 'flex';
      host.style.visibility = 'visible';
      host.style.opacity = '1';
      host.style.zIndex = '2147483000';
      host.style.pointerEvents = 'none';
    } catch (err) {
      if (root.console && root.console.warn) root.console.warn(text);
      return;
    }
    try {
      el = host.querySelector('[data-ed-fav-error]');
      if (!el) {
        el = doc.createElement('div');
        el.setAttribute('data-ed-fav-error', '');
        el.setAttribute('role', 'status');
        el.className = 'ed-fav-error is-visible';
        host.appendChild(el);
      }
      el.textContent = text;
      el.removeAttribute('hidden');
      el.classList.add('is-visible');
      el.style.display = 'block';
      el.style.visibility = 'visible';
      el.style.opacity = '1';
      el.style.position = 'relative';
      el.style.zIndex = '2147483000';
    } catch (err2) {
      if (root.console && root.console.warn) root.console.warn(text);
      return;
    }
    try {
      pinErrorHost(host, el);
    } catch (err3) {}
    if (showError._onPin) {
      root.removeEventListener('scroll', showError._onPin, true);
      root.removeEventListener('resize', showError._onPin);
      if (root.visualViewport) {
        root.visualViewport.removeEventListener('resize', showError._onPin);
        root.visualViewport.removeEventListener('scroll', showError._onPin);
      }
    }
    showError._onPin = function () {
      pinErrorHost(host, el);
    };
    root.addEventListener('scroll', showError._onPin, true);
    root.addEventListener('resize', showError._onPin);
    if (root.visualViewport) {
      root.visualViewport.addEventListener('resize', showError._onPin);
      root.visualViewport.addEventListener('scroll', showError._onPin);
    }
    if (showError._timer) clearTimeout(showError._timer);
    showError._timer = setTimeout(function () {
      el.classList.remove('is-visible');
      el.style.display = 'none';
      el.setAttribute('hidden', '');
      if (showError._onPin) {
        root.removeEventListener('scroll', showError._onPin, true);
        root.removeEventListener('resize', showError._onPin);
        if (root.visualViewport) {
          root.visualViewport.removeEventListener('resize', showError._onPin);
          root.visualViewport.removeEventListener('scroll', showError._onPin);
        }
        showError._onPin = null;
      }
    }, 4000);
  }

  function setHeartEl(rootEl, saved) {
    if (!rootEl || !rootEl.setAttribute) return;
    var wrap = rootEl.hasAttribute && rootEl.hasAttribute('data-ed-fav-root')
      ? rootEl
      : rootEl.closest
        ? rootEl.closest('[data-ed-fav-root], .ed-wishlist')
        : null;
    var btn = rootEl.getAttribute && rootEl.getAttribute('data-ed-fav-toggle') != null
      ? rootEl
      : wrap && wrap.querySelector
        ? wrap.querySelector('[data-ed-fav-toggle]')
        : rootEl;
    if (wrap) {
      if (saved) wrap.setAttribute('data-ed-fav-saved', 'true');
      else wrap.removeAttribute('data-ed-fav-saved');
      wrap.classList.toggle('is-saved', !!saved);
    }
    if (btn && btn.setAttribute) {
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      var label = saved
        ? state.i18n.unsave || 'Fjern fra gemte produkter'
        : state.i18n.save || 'Gem produkt';
      btn.setAttribute('aria-label', label);
    }
  }

  function syncHearts(scope) {
    var doc = root.document;
    if (!doc || !doc.querySelectorAll) return;
    var nodes = (scope && scope.querySelectorAll ? scope : doc).querySelectorAll('[data-ed-fav-root], [data-ed-fav-toggle]');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var id =
        (node.getAttribute && (node.getAttribute('data-ed-product-id') || node.getAttribute('data-usf-pid'))) ||
        '';
      if (!id && node.querySelector) {
        var btn = node.querySelector('[data-ed-fav-toggle]');
        if (btn) id = btn.getAttribute('data-ed-product-id') || '';
      }
      if (!id && node.closest) {
        var row = node.closest('[data-usf-pid], [data-product-id], [product-selector]');
        if (row) {
          id =
            row.getAttribute('data-usf-pid') ||
            row.getAttribute('data-product-id') ||
            row.getAttribute('product-selector') ||
            '';
        }
      }
      if (!id) continue;
      setHeartEl(node, isSaved(id));
    }
  }

  function syncFavoriteRows() {
    var doc = root.document;
    if (!doc || !state.isFavoritesPage || !doc.querySelectorAll) return;
    var rows = doc.querySelectorAll(
      '#usf_container .ed-usf-list-row[data-usf-pid], #usf_container .ed-usf-grid-card[data-usf-pid], #usf_container .usf-sr-product[data-usf-pid]'
    );
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var id = numericId(row.getAttribute('data-usf-pid') || row.getAttribute('data-product-id'));
      var keep = shouldKeepFavoritesRow(id, state.productIds, state.restrictedIds);
      if (keep) {
        row.removeAttribute('hidden');
        row.removeAttribute('data-ed-fav-hidden');
        if (row.style) row.style.display = '';
      } else {
        row.setAttribute('hidden', '');
        row.setAttribute('data-ed-fav-hidden', '1');
        if (row.style) row.style.display = 'none';
      }
    }
  }

  function refreshRestrictedIds() {
    var pageIds = root.__edRestrictedProductIds;
    if (Array.isArray(pageIds) && pageIds.length) {
      state.restrictedIds = uniqueIds(pageIds);
      return;
    }
    var published = root.__edCompanyFavorites && root.__edCompanyFavorites.restrictedIds;
    if (Array.isArray(published) && published.length) {
      state.restrictedIds = uniqueIds(published);
    }
  }

  function rememberCollectionItems(items) {
    if (!Array.isArray(items) || !items.length) return;
    state.collectionItems = items.slice();
  }

  function adoptPagePayload() {
    if (Array.isArray(root.__edCompanyWishlistProducts) && root.__edCompanyWishlistProducts.length) {
      state.products = root.__edCompanyWishlistProducts.slice();
    }
    refreshRestrictedIds();
    if (root.__edFavoritesPage === true || root.__edSpecialProductsPage === true) {
      state.isFavoritesPage = true;
    }
    if (cfg && cfg.i18n) state.i18n = cfg.i18n;
  }

  function rememberProducts(items) {
    if (!root._edBssPriceFrom || typeof root._edBssPriceFrom.rememberProduct !== 'function') return;
    (items || []).forEach(function (item) {
      if (item) root._edBssPriceFrom.rememberProduct(item);
    });
  }

  function cacheItem(item) {
    var id = itemId(item);
    if (!id || !item) return;
    if (!state.itemCache) state.itemCache = {};
    state.itemCache[id] = normalizeUsfItem(cloneUsfProduct(item));
  }

  function cachedProducts() {
    var cache = state.itemCache || {};
    return Object.keys(cache).map(function (id) {
      return cache[id];
    });
  }

  function adoptSavedProduct(id) {
    if (state.products.some(function (item) {
      return itemId(item) === id;
    })) {
      return;
    }
    var cached = state.itemCache && state.itemCache[id];
    if (cached) state.products.push(cached);
  }

  function applyFavoritesToUsf() {
    if (!state.isFavoritesPage) return;
    refreshRestrictedIds();
    var search = root.usf && root.usf.search;
    var items = search && search.result && search.result.items;
    if (!Array.isArray(items)) return;
    items.forEach(cacheItem);
    state.products.forEach(cacheItem);
    var collection = state.collectionItems && state.collectionItems.length
      ? state.collectionItems
      : items;
    var next = applyFavoritesTable({
      collectionItems: collection,
      savedProducts: state.products.concat(cachedProducts()),
      savedIds: state.productIds,
      restrictedIds: state.restrictedIds,
      isShownId: shownChecker(),
    }).filter(function (item) {
      var id = itemId(item);
      return id && !hiddenCheckerId(id);
    });
    try {
      items.splice.apply(items, [0, items.length].concat(next));
    } catch (e) {
      try {
        search.result.items = next;
      } catch (e2) {}
    }
    if (typeof search.result.total === 'number') search.result.total = next.length;
    try {
      if (root.usf.app && typeof root.usf.app.$forceUpdate === 'function') {
        root.usf.app.$forceUpdate();
      }
    } catch (e3) {}
  }

  function refreshInsertedPrices(inserted) {
    if (!inserted || !inserted.length) return;
    rememberProducts(inserted);
    if (root._edBssPriceFrom && typeof root._edBssPriceFrom.refresh === 'function') {
      root._edBssPriceFrom.refresh();
    }
  }

  function mergeFavoriteItems(items) {
    if (!state.isFavoritesPage) return items || [];
    refreshRestrictedIds();
    rememberCollectionItems(items);
    (items || []).forEach(cacheItem);
    var merged = mergeUsfItems(items, {
      favoritesPage: true,
      savedProducts: state.products,
      savedIds: state.productIds,
      restrictedIds: state.restrictedIds,
      hiddenIds: [],
      isShownId: shownChecker(),
    }).filter(function (item) {
      var id = itemId(item);
      return id && !hiddenCheckerId(id);
    });
    refreshInsertedPrices(insertedFavoriteItems(merged, items));
    return merged;
  }

  function request(path, options) {
    options = options || {};
    var url = state.basePath + path;
    var empty = { ok: false, status: 0, data: null, networkError: true };
    var fetchFn = typeof root.fetch === 'function' ? root.fetch : typeof fetch === 'function' ? fetch : null;

    return new Promise(function (resolve) {
      var timeoutId = null;
      var settled = false;
      function done(result) {
        if (settled) return;
        settled = true;
        if (timeoutId) {
          clearTimeout(timeoutId);
          timeoutId = null;
        }
        resolve(result || empty);
      }
      try {
        if (typeof fetchFn !== 'function') {
          done(empty);
          return;
        }
        var init = {
          method: options.method || 'GET',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: options.body ? JSON.stringify(options.body) : undefined,
        };
        if (typeof root.AbortController === 'function') {
          var controller = new root.AbortController();
          init.signal = controller.signal;
          timeoutId = setTimeout(function () {
            try {
              controller.abort();
            } catch (e) {}
          }, options.timeoutMs || 8000);
        }
        var pending;
        try {
          pending = fetchFn(url, init);
        } catch (syncErr) {
          done(empty);
          return;
        }
        if (!pending || typeof pending.then !== 'function') {
          done(empty);
          return;
        }
        pending.then(
          function (response) {
            var type = '';
            try {
              type = (response && response.headers && response.headers.get('content-type')) || '';
            } catch (e) {}
            if (!response || !type || type.indexOf('json') === -1) {
              done({
                ok: false,
                status: (response && response.status) || 0,
                data: null,
                networkError: !response,
              });
              return;
            }
            var jsonPromise;
            try {
              jsonPromise = response.json();
            } catch (e2) {
              done({ ok: false, status: response.status, data: null });
              return;
            }
            Promise.resolve(jsonPromise).then(
              function (data) {
                done({ ok: !!response.ok, status: response.status, data: data });
              },
              function () {
                done({ ok: false, status: response.status, data: null });
              }
            );
          },
          function () {
            done(empty);
          }
        );
      } catch (err) {
        done(empty);
      }
    });
  }

  function hydrateMissing() {
    if (!state.isFavoritesPage || !state.loggedIn) return Promise.resolve();
    var have = {};
    state.products.forEach(function (product) {
      var id = itemId(product);
      if (id) have[id] = true;
    });
    var missing = state.productIds.filter(function (id) {
      return !have[id];
    });
    if (!missing.length) return Promise.resolve();

    function fetchOne(id) {
      var urls = [
        '/search/suggest.json?q=' + encodeURIComponent('id:' + id) + '&resources[type]=product&resources[limit]=4',
        '/search/suggest.json?q=' + encodeURIComponent(id) + '&resources[type]=product&resources[limit]=6',
      ];
      function tryUrl(index) {
        if (index >= urls.length) return Promise.resolve(null);
        return fetch(urls[index], { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .then(function (data) {
            var resources = data && data.resources && data.resources.results && data.resources.results.products;
            var products = resources || (data && data.products) || [];
            var match = null;
            for (var i = 0; i < products.length; i++) {
              if (numericId(products[i].id) === id) {
                match = products[i];
                break;
              }
            }
            if (!match) return tryUrl(index + 1);
            var handle = match.handle || '';
            if (!handle) return shopJsToUsfItem(match);
            return fetch('/products/' + encodeURIComponent(handle) + '.js', {
              credentials: 'same-origin',
              headers: { Accept: 'application/json' },
            })
              .then(function (r) {
                return r.ok ? r.json() : null;
              })
              .then(function (full) {
                var item = shopJsToUsfItem(full || match);
                if (full && root._edBssPriceFrom && typeof root._edBssPriceFrom.rememberProduct === 'function') {
                  root._edBssPriceFrom.rememberProduct(full);
                }
                return item;
              })
              .catch(function () {
                return shopJsToUsfItem(match);
              });
          })
          .catch(function () {
            return tryUrl(index + 1);
          });
      }
      return tryUrl(0);
    }

    return Promise.all(missing.map(fetchOne)).then(function (found) {
      var added = [];
      found.forEach(function (item) {
        if (!item || !itemId(item) || hiddenCheckerId(itemId(item))) return;
        state.products.push(item);
        added.push(item);
      });
      if (!added.length) return;
      rememberProducts(added);
      publishConfig();
      if (root.usf && typeof root.usf.fetch === 'function' && root.usf.search) {
        root.usf.fetch(root.usf.search);
      }
    });
  }

  function afterChange() {
    if (state.isFavoritesPage) {
      state.productIds.forEach(adoptSavedProduct);
      applyFavoritesToUsf();
    }
    publishConfig();
    syncHearts();
    syncFavoriteRows();
  }

  function toggle(productId) {
    var id = numericId(productId);
    if (!id) return Promise.resolve(null);
    if (!state.loggedIn) {
      loginRedirect();
      return Promise.resolve(null);
    }
    if (!state.hasCompany) {
      showError(state.i18n.noCompany || 'Gemte produkter kræver en virksomhedskonto.');
      return Promise.resolve(null);
    }
    if (state.inflight[id]) return state.inflight[id];

    var action = isSaved(id) ? 'remove' : 'add';
    var snap = applyOptimistic(state, id, action);
    afterChange();
    var startedAt = Date.now();

    function finishFailure(kind) {
      try {
        if (kind === 'login') loginRedirect();
        else if (kind === 'company') {
          showError(state.i18n.noCompany || 'Gemte produkter kræver en virksomhedskonto.');
        } else {
          showError(state.i18n.error);
        }
      } catch (e0) {
        try {
          showError(state.i18n.error);
        } catch (e00) {}
      }
      var wait = Math.max(0, 180 - (Date.now() - startedAt));
      return new Promise(function (resolve) {
        setTimeout(function () {
          try {
            rollbackOptimistic(state, snap);
          } catch (e) {}
          try {
            afterChange();
          } catch (e2) {}
          try {
            if (kind !== 'login') {
              if (kind === 'company') {
                showError(state.i18n.noCompany || 'Gemte produkter kræver en virksomhedskonto.');
              } else {
                showError(state.i18n.error);
              }
            }
          } catch (e3) {
            try {
              showError(state.i18n.error);
            } catch (e4) {}
          }
          resolve(null);
        }, wait);
      });
    }

    var pending = request('/toggle', {
      method: 'POST',
      body: { productId: id, action: action },
    })
      .then(
        function (result) {
          if (isFailedToggleResult(result)) return finishFailure(toggleFailureKind(result));
          try {
            applyServerList(state, result.data.productIds);
            afterChange();
            return result.data;
          } catch (err) {
            return finishFailure('error');
          }
        },
        function () {
          return finishFailure('error');
        }
      )
      .catch(function () {
        return finishFailure('error');
      })
      .then(function (data) {
        delete state.inflight[id];
        return data;
      });

    state.inflight[id] = pending;
    return pending;
  }

  function attrId(el) {
    if (!el || !el.getAttribute) return '';
    return (
      el.getAttribute('data-ed-product-id') ||
      el.getAttribute('data-product-id') ||
      el.getAttribute('data-usf-pid') ||
      el.getAttribute('product-selector') ||
      ''
    );
  }

  function onClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var btn = target.closest('[data-ed-fav-toggle]');
    if (btn && btn.hasAttribute && !btn.hasAttribute('data-ed-fav-toggle')) btn = null;
    var wrap = target.closest('[data-ed-fav-root], .ed-wishlist');
    if (!btn && wrap && wrap.querySelector) btn = wrap.querySelector('[data-ed-fav-toggle]');
    if (!btn && !wrap) return;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    var id = attrId(btn) || attrId(wrap);
    if (!id && (btn || wrap) && (btn || wrap).closest) {
      var row = (btn || wrap).closest('[data-usf-pid], [data-product-id], [product-selector]');
      id = attrId(row);
    }
    if (!state.loggedIn) {
      loginRedirect();
      return;
    }
    if (!state.inflight[numericId(id)]) setHeartEl(btn, !isSaved(id));
    toggle(id);
  }

  function bindUsf() {
    if (!root.usf || !root.usf.event || typeof root.usf.event.add !== 'function') return false;
    if (bindUsf._done) return true;
    bindUsf._done = true;
    root.usf.event.add('sr_updated', function () {
      syncHearts();
      syncFavoriteRows();
    });
    root.usf.event.add('sr_dataReceived', function () {
      syncHearts();
      syncFavoriteRows();
    });
    return true;
  }

  root.__edMergeCompanyFavorites = function (items) {
    try {
      return mergeFavoriteItems(items);
    } catch (err) {
      return items || [];
    }
  };
  root._edUsfSyncWishlist = function () {
    syncHearts();
    syncFavoriteRows();
  };
  root._edUsfEnsureWishlist = function (card) {
    syncHearts(card);
  };
  root._edUsfRefreshWishlist = function () {
    syncHearts();
  };

  publishConfig();

  if (root.document && root.document.addEventListener) {
    root.document.addEventListener('click', onClick, true);
    if (root.document.readyState === 'loading') {
      root.document.addEventListener('DOMContentLoaded', function () {
        adoptPagePayload();
        afterChange();
        bindUsf();
      });
    } else {
      adoptPagePayload();
      afterChange();
      bindUsf();
    }
  }

  var tries = 0;
  var timer = setInterval(function () {
    tries += 1;
    bindUsf();
    syncHearts();
    if (tries > 40) clearInterval(timer);
  }, 250);

  if (typeof fetch === 'function' && !root.__edFavJsonRewrite) {
    root.__edFavJsonRewrite = true;
    var nativeFetch = fetch.bind(root);
    root.fetch = function (input, init) {
      try {
        if (typeof input === 'string') input = rewriteProductJsonUrl(input);
        else if (typeof Request !== 'undefined' && input instanceof Request) {
          var next = rewriteProductJsonUrl(input.url);
          if (next !== input.url) input = new Request(next, input);
        }
      } catch (e) {}
      return nativeFetch(input, init);
    };
  }

  if (state.loggedIn && state.hasCompany) {
    request('/list')
      .then(function (result) {
        if (isIgnorableFavoritesResult(result)) return;
        applyServerList(state, result.data.productIds);
        afterChange();
        return hydrateMissing();
      })
      .catch(function () {});
  }
})(typeof window !== 'undefined' ? window : this);
